import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatWindowComponent } from './chat-window/chat-window.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ChatModalComponent } from './chat-modal/chat-modal.component';
import { AccountModule } from '@app/pages/account/account.module';
import { MatMenuModule as MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        AccountModule,
        ChatWindowComponent,
        ChatModalComponent
    ],
    exports: [
        ChatWindowComponent
    ]
})
export class LiveChatModule { }
